export function validateConfiguration(config) {
    const isResourceValid = config.resourceSource === 'customfield' && config.resourceFieldId;
    const hasStartField = config.startFieldId;
    const hasEndField = config.endFieldId;
    const hasProject = config.projectId;
    const hasIssueType = config.issuetypeId;
    return isResourceValid && hasStartField && hasEndField && hasProject && hasIssueType;
}
